import { Mail, MessageCircle, Phone, ShieldCheck } from "lucide-react";
import { useDocstate } from "@/context/DocstateContext";

export default function DocstateAgents() {
  const data = useDocstate();
  const agents = data?.agents || [];
  return (
    <div className="ds-bg min-h-screen pt-16" data-testid="docstate-agents">
      <div className="mx-auto max-w-7xl px-4 pt-12 sm:px-8 lg:px-12">
        <p className="ds-eyebrow">Meet the Team</p>
        <h1 className="ds-display mt-2 text-3xl font-medium text-white lg:text-4xl">Your Dubai Property Advisors</h1>
        <p className="mt-3 max-w-xl text-sm text-[#C9BBB2]">RERA-registered specialists across Dubai's prime communities — fluent in your language, invested in your goals.</p>

        <div className="mt-10 grid grid-cols-1 gap-6 pb-16 sm:grid-cols-2 lg:grid-cols-3">
          {agents.map((a) => {
            const wa = ((a.whatsapp || a.phone || "") + "").replace(/[^\d]/g, "");
            return (
              <div key={a.id} className="ds-card overflow-hidden" data-testid={`agent-${a.id}`}>
                <div className="aspect-[4/5] overflow-hidden">
                  {a.photo ? <img src={a.photo} alt={a.name} loading="lazy" className="h-full w-full object-cover" /> : <div className="h-full w-full bg-[#121214]" />}
                </div>
                <div className="p-5">
                  <p className="ds-display text-lg font-semibold text-white">{a.name}</p>
                  <p className="text-xs text-[#C9A24B]">{a.title}</p>
                  {a.rera_brn && <p className="mt-1.5 inline-flex items-center gap-1 text-[11px] text-[#8A7A6F]"><ShieldCheck className="h-3 w-3 text-[#3CB98A]" /> {a.rera_brn} · {a.experience_years || 0} yrs</p>}
                  {a.bio && <p className="mt-3 text-xs leading-relaxed text-[#9D8D83]">{a.bio}</p>}
                  {a.specialties && a.specialties.length > 0 && (
                    <div className="mt-3 flex flex-wrap gap-1.5">
                      {a.specialties.map((s) => <span key={s} className="rounded-full border border-[#C9A24B]/20 px-2.5 py-0.5 text-[10px] text-[#C9BBB2]">{s}</span>)}
                    </div>
                  )}
                  {a.languages && a.languages.length > 0 && <p className="mt-3 text-[11px] text-[#8A7A6F]">Speaks: {a.languages.join(", ")}</p>}
                  <div className="mt-4 flex gap-2">
                    {a.phone && <a href={`tel:${a.phone}`} aria-label="Call" className="flex h-10 flex-1 items-center justify-center rounded-full border border-[#C9A24B]/30 text-[#F3E5AB] hover:bg-[#C9A24B]/10"><Phone className="h-4 w-4" /></a>}
                    {a.email && <a href={`mailto:${a.email}`} aria-label="Email" className="flex h-10 flex-1 items-center justify-center rounded-full border border-[#C9A24B]/30 text-[#F3E5AB] hover:bg-[#C9A24B]/10"><Mail className="h-4 w-4" /></a>}
                    {wa && <a href={`https://wa.me/${wa}`} target="_blank" rel="noreferrer" data-testid={`agent-whatsapp-button-${a.id}`} aria-label="WhatsApp" className="ds-gold-btn h-10 flex-1"><MessageCircle className="h-4 w-4" /></a>}
                  </div>
                </div>
              </div>
            );
          })}
          {agents.length === 0 && <p className="text-sm text-[#8A7A6F]">Our team details are being updated.</p>}
        </div>
      </div>
    </div>
  );
}
